const LISTAR_DADOS = (state, payload) => {
    state.notificacoes = payload
}

const LIMPAR_DADOS = (state) => {
    state.notificacoes = []
}

const REMOVER_NOTIFICACAO = (state, id) => {
    state.notificacoes = state.notificacoes.filter(notificacao => notificacao.id !== id)
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}


export {
    LISTAR_DADOS,
    LIMPAR_DADOS,
    REMOVER_NOTIFICACAO,
    CARREGANDO,
}
